export enum AuthenticationResponseErrorType {
  message,
  redirectUrl
}
